var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1478 12.3213C15.0158 12.3213 12.4693 14.8678 12.4693 17.9998C12.4693 21.1318 15.0177 23.6784 18.1478 23.6784C21.2779 23.6784 23.8263 21.1318 23.8263 17.9998C23.8263 14.8678 21.2798 12.3213 18.1478 12.3213Z",
    fill: "#08B1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1867 0H10.8133C4.85053 0 0 4.85053 0 10.8133V25.1867C0 31.1495 4.85053 36 10.8133 36H25.1867C31.1495 36 36 31.1495 36 25.1867V10.8133C36 4.85053 31.1495 0 25.1867 0ZM18.1478 26.8655C13.2594 26.8655 9.28232 22.8884 9.28232 18C9.28232 13.1116 13.2594 9.13453 18.1478 9.13453C23.0362 9.13453 27.0133 13.1116 27.0133 18C27.0133 22.8884 23.0362 26.8655 18.1478 26.8655ZM27.5305 10.6484C26.3653 10.6484 25.4198 9.70295 25.4198 8.53768C25.4198 7.37242 26.3653 6.42695 27.5305 6.42695C28.6958 6.42695 29.6413 7.37242 29.6413 8.53768C29.6413 9.70295 28.6958 10.6484 27.5305 10.6484Z",
    fill: "#08B1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2eccb9183a4047822777f32fa917331a.svg";
export { ForwardRef as ReactComponent };